import { groupTiersQueryKeys } from './group-tiers-query-keys.utils'
import type { QueryClient } from '@tanstack/vue-query'

/**
 * Admin list + member join catalogue must stay in sync after status / popular /
 * delete / create / edit / sync — otherwise Preview + Subscribe CTA stay stale.
 */
export const invalidateTiersListAndJoinPlans = (queryClient: QueryClient, groupId: string, locationId: string): void => {
  void queryClient.invalidateQueries({ queryKey: groupTiersQueryKeys.list(groupId, locationId) })
  void queryClient.invalidateQueries({ queryKey: groupTiersQueryKeys.plans(groupId, locationId) })
}
